<template>
    <div v-if="showStep" class="step-card-wrapper">
        <generic-step-card
            :title="stepTitle"
            :current-step-name="currentStepName"
            :step="step"
            :steps="steps"
            :is-preview="isPreview"
            :is-brief-accepted="isBriefAccepted"
            :is-brief-editable="isBriefEditable"
            :brief="brief"
            hide-view-button
        >
            <template slot="details">
                <content-rights-summary :brief="brief" />
                <g-form>
                    <g-form-item :required="true" label="">
                        <g-media-object>
                            <template slot="left">
                                <g-checkbox :checked="briefAgreed" class="agreement-checkbox" :disabled="true" />
                            </template>
                            <template>
                                <p v-if="!usesAlternateTerms">
                                    I accept the terms of the foregoing proposal and agree to the
                                    <g-link tag="a" href="https://grin.co/privacy/" target="_blank" @click.stop>Privacy Policy</g-link>
                                    and <g-link tag="a" href="https://grin.co/terms-of-use-influencers/" target="_blank" @click.stop>Terms</g-link>
                                </p>
                                <p v-else>
                                    I accept the above terms and conditions with {{ brief.brand.name }} and
                                    agree to the terms provided by {{ brief.brand.name }}'s service provider,
                                    Grin via the <g-link tag="a" href="https://grin.co/privacy/" target="_blank" @click.stop>Grin Privacy Policy</g-link>
                                    and <g-link tag="a" href="https://grin.co/terms-of-use-influencers/" target="_blank" @click.stop>Grin Terms</g-link>.
                                </p>
                            </template>
                        </g-media-object>
                    </g-form-item>
                </g-form>
            </template>
        </generic-step-card>
    </div>
</template>

<script>
    import {get} from 'lodash';
    import GenericStepCard from '../GenericStepCard';
    import {NAME_CONTENT_AGREEMENT} from '../../../../../constants/activation-brief-steps';
    import StepCardViewMixin from '../mixins/StepCardViewMixin';
    import ContentRightsSummary from '../content-rights/ContentRightsSummary';

    export default {
        name:       'ContentAgreementStepCardView',
        components: {
            ContentRightsSummary,
            GenericStepCard,
        },
        mixins: [
            StepCardViewMixin,
        ],
        computed: {
            stepName() {
                return NAME_CONTENT_AGREEMENT;
            },
            briefAgreed() {
                return !!get(this, 'brief.accepted_at');
            },
            usesAlternateTerms(){
                return get(window.SERVER_DATA, 'alternate_terms_of_service', false);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .step-card-wrapper {
        margin-bottom: $g-spacing-5;
    }
    .step-card-current {
        .ant-form-item {
            color: white;
        }
    }
</style>
